import {initMainHeader} from '@/js/src/header-init';
import '../scss/pages/404.scss';

initMainHeader();
